import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { useDocsConfig } from '../context/DocsConfigContext';

const ConfigPanel = () => {
  const { baseUrl, apiKey, setApiKey, setBaseUrl } = useDocsConfig();
  const [copiedHeader, setCopiedHeader] = useState(false);
  const [copiedQuery, setCopiedQuery] = useState(false);

  const headerSample = `X-API-Key: ${apiKey || 'email@example.com:your_api_key_here'}`;
  const querySample = `?apiKey=${encodeURIComponent(apiKey || 'email@example.com:your_api_key_here')}`;

  const copy = async (text, which) => {
    try {
      await navigator.clipboard.writeText(text);
      if (which === 'header') {
        setCopiedHeader(true);
        setTimeout(() => setCopiedHeader(false), 1500);
      } else {
        setCopiedQuery(true);
        setTimeout(() => setCopiedQuery(false), 1500);
      }
    } catch {}
  };

  return (
    <div className="mb-6 p-4 bg-gray-900 border border-gray-800 rounded-lg">
      <div className="flex flex-col md:flex-row md:items-end gap-4">
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-300 mb-1">Base URL</label>
          <input
            type="text"
            value={baseUrl}
            onChange={(e) => setBaseUrl(e.target.value)}
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="http://localhost:8000/api/v1"
          />
          <p className="text-xs text-gray-500 mt-1">Used for examples and in the API explorer.</p>
        </div>
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-300 mb-1">API Key</label>
          <input
            type="password"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="email@example.com:your_api_key_here"
          />
          <p className="text-xs text-gray-500 mt-1">Stored locally in your browser. Format: email:api_key</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4">
        <div className="bg-gray-800 rounded border border-gray-700 p-3 flex items-center justify-between">
          <code className="text-sm text-gray-300">{headerSample}</code>
          <button onClick={() => copy(headerSample, 'header')} className="text-xs text-gray-400 hover:text-white flex items-center gap-1">
            {copiedHeader ? (<><Check className="w-3 h-3" />Copied</>) : (<><Copy className="w-3 h-3" />Copy</>)}
          </button>
        </div>
        <div className="bg-gray-800 rounded border border-gray-700 p-3 flex items-center justify-between">
          <code className="text-sm text-gray-300">{querySample}</code>
          <button onClick={() => copy(querySample, 'query')} className="text-xs text-gray-400 hover:text-white flex items-center gap-1">
            {copiedQuery ? (<><Check className="w-3 h-3" />Copied</>) : (<><Copy className="w-3 h-3" />Copy</>)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfigPanel;
